import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {endOfWeek, startOfWeek} from 'date-fns';

export const setFilters = createAsyncThunk(
  'staffOnlyTimesheetFilters/setFilters',
  async (args: any) => {
    return args;
  },
);

const staffOnlyTimesheetFilters = createSlice({
  name: 'staffOnlyTimesheetFilters',
  initialState: {
    selectedFilters: {
      startDate: startOfWeek(new Date()).getTime(),
      endDate: endOfWeek(new Date()).getTime(),
      allTime: [],
      staff: [],
      clients: [],
      locations: [],
      types: [],
      status: ['completed', 'non-clinical'],
    },
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(setFilters.fulfilled, (state, {payload}) => {
      Object.assign(state, {selectedFilters: payload});
    });
  },
});

export default staffOnlyTimesheetFilters.reducer;
